import { Injectable } from '@angular/core';
import { URLSearchParams } from '@angular/http'
import { PagedResult } from 'app/models/PagedResult';
import { User } from 'app/models/user';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { HttpBackendService } from './http-backend.service';

@Injectable()
export class UserService {

  constructor(private _http: HttpBackendService) { }

  public getUsersPerPage(isDesc: boolean, count: number, skip: number): Observable<PagedResult<User>>
  {
    let params = new URLSearchParams();

    params.append('$orderby', "Employee/IsLocked" + (!isDesc ? " desc" : " asc") + ",IsActivated" + (isDesc ? " desc" : " asc") + ",Name");
    params.append("$expand", "Employee($select=Email,IsLocked)");
    params.append('$top', count ? count.toString() : null);
    params.append('$skip', skip ? skip.toString() : null);
    params.append('$count', "true");

    return this._http.get("/api/odata/users", params)
      .map(resp => {
        let pagedResult = resp.json();
        let result = new PagedResult<User>();

        result.items = _.map(pagedResult.value, function (value) {
          return UserService.convertUserDTO2Object(value);
        });

        result.totalCount = pagedResult["@odata.count"];

        return result;
      });
  }

  public getUsers(): Observable<User[]>
  {
    let params = new URLSearchParams();
    params.append("$expand", "Employee($select=Email,IsLocked),AttachedServiceAreas($select=ServiceAreaId)");

    return this._http.get("/api/odata/users", params)
      .map(resp => {
        let users = _.map(resp.json().value, value => UserService.convertUserDTO2Object(value));
        return users;
      });
  }

  public getUser(userId: number): Observable<User>
  {
    let params = new URLSearchParams();
    params.append("$expand", "Employee($select=Email,IsLocked),AttachedServiceAreas($select=ServiceAreaId)");
    
    return this._http.get(`/api/odata/users(${userId})`, params)
      .map(resp => {
        return UserService.convertUserDTO2Object(resp.json());
      });
  }

  public createUser(user: User): Observable<User>
  {
    let dto = {
      Name: user.name,
      Email: user.email,
      Role: UserService.domainRoleToCPA(user.role, user.permissions),
      ServiceAreaIds: user.serviceAreaIds,
      IsAllowedAllServiceArea: user.isAllowedAllServiceArea,
      CanCancelCalls: user.canCancelCalls
    };
    return this._http.post("/api/user/management", dto, null, true)
      .map(resp => {
        user.id = resp.json().Id;
        return user;
      });
  }

  public patchUser(user: User): Observable<User>
  {
    let dto = {
      IsLocked: user.status == User.Status.Locked ? true : false,
      Name: user.name,
      Role: UserService.domainRoleToCPA(user.role, user.permissions),
      ServiceAreaIds: user.serviceAreaIds,
      IsAllowedAllServiceArea: user.isAllowedAllServiceArea,
      CanCancelCalls: user.canCancelCalls
    };
    return this._http.patch(`/api/user/management/${user.id}`, dto, null, true)
      .map(resp => {
        return user;
      });
  }

  public deleteUser(userId: number): Observable<boolean>
  {
    return this._http.delete(`/api/user/management/${userId}`, null, true)
      .map(resp => {
        return true;
      });
  }
}

export namespace UserService {

  export function convertUserDTO2Object(dto : any, user : User = new User()): User {
    user.id = dto.Id;
    user.name = dto.Name;
    user.email = dto.Employee.Email;
    user.isAllowedAllServiceArea = dto.IsAllowedAllServiceArea;
    user.canCancelCalls = dto.CanCancelCalls;
    user.status = dto.Employee.IsLocked ? User.Status.Locked : dto.IsActivated ? User.Status.Active : User.Status.NotActive;
    user.serviceAreaIds = dto.AttachedServiceAreas === undefined ? null : dto.AttachedServiceAreas.map(attachedServiceArea => attachedServiceArea.ServiceAreaId);
    let rolePermission = convertCPARoleToDomainPermissions(dto.Role);
    user.role = rolePermission[0];
    user.permissions = rolePermission[1];
    return user;
  }

  export function convertCPARoleToDomainPermissions(rolesCpaString: string): [User.Role, User.Permissions]
  {
    let roleCpa: RoleCPA = RoleCPA.None;
    let roles: string[] = rolesCpaString.split(',').map(role => role.trim());

    roles.forEach(role => {
      roleCpa |= RoleCPA[role];
    });

    if(roleCpa === undefined)
    {
      throw new Error(`An error occurred while converting the role. The role ${rolesCpaString} does not exist`);
    }
    let userRole: User.Role;
    let permission: User.Permissions = User.Permissions.None;
    if(roleCpa == RoleCPA.All)
    {
      userRole = User.Role.Administrator;
      permission = User.Permissions.All;
    }
    else
    {
      userRole = User.Role.Manager;

      if((roleCpa & RoleCPA.Read) == RoleCPA.Read)
      {
        permission |= User.Permissions.Read;
      }

      if((roleCpa & RoleCPA.Write) == RoleCPA.Write)
      {
        permission |= User.Permissions.Write;
      }
    }
    return [userRole, permission];
  }

  export function domainRoleToCPA(role: User.Role, permission: User.Permissions): RoleCPA
  {
    if(role == User.Role.Administrator)
    {
      return RoleCPA.All;
    }
    else if(role == User.Role.Manager)
    {
      let roleCPA: RoleCPA = RoleCPA.None;

      if((permission & User.Permissions.Read) == User.Permissions.Read)
      {
        roleCPA |= RoleCPA.Read;
      }

      if((permission & User.Permissions.Write) == User.Permissions.Write)
      {
        roleCPA |= RoleCPA.Write;
      }

      return roleCPA;
    }
    else
    {
      throw new Error("Role does not exist");
    }
  }

  export enum RoleCPA
  {
    None = 0,
    Read = 1,
    Write = 1 << 1,
    UserManagement = 1 << 2,
    All = ~None
  }

}



// WEBPACK FOOTER //
// /app/SPA/src/app/services/user.service.ts